import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const KEY = "aa_cookie_consent";

const CookieNotice = ({ forceOpen, onClose }) => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (forceOpen) setVisible(true);
  }, [forceOpen]);

  const choose = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch (e) {
      /* ignore */
    }
    setVisible(false);
    onClose?.();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-notice"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-4 bottom-4 z-50 mx-auto max-w-2xl rounded-2xl border border-gold/20 bg-[#0c0c10]/95 p-5 shadow-2xl shadow-black/60 backdrop-blur-xl sm:bottom-6"
          role="dialog"
          aria-label={t("footer.cookies")}
        >
          <div className="flex items-start gap-4">
            <Cookie className="mt-0.5 h-6 w-6 shrink-0 text-gold" aria-hidden="true" />
            <div className="flex-1">
              <p className="text-sm leading-relaxed text-slate-300">{t("cookies.text")}</p>
              <div className="mt-4 flex gap-3">
                <button
                  type="button"
                  data-testid="cookie-accept-button"
                  onClick={() => choose("accepted")}
                  className="rounded-full bg-gold px-6 py-2.5 text-[11px] font-bold uppercase tracking-widest text-[#08080A] transition-colors hover:bg-gold-light"
                >
                  {t("cookies.accept")}
                </button>
                <button
                  type="button"
                  data-testid="cookie-decline-button"
                  onClick={() => choose("declined")}
                  className="rounded-full border border-white/15 px-6 py-2.5 text-[11px] font-bold uppercase tracking-widest text-slate-300 transition-colors hover:border-gold/50 hover:text-gold"
                >
                  {t("cookies.decline")}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieNotice;
